var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19733 19.2C5.87782 19.2 4.81021 20.28 4.81021 21.6C4.81021 22.92 5.87782 24 7.19733 24C8.51684 24 9.59644 22.92 9.59644 21.6C9.59644 20.28 8.51684 19.2 7.19733 19.2ZM0 1.2C0 1.86 0.5398 2.4 1.19955 2.4H2.39911L6.71751 11.508L5.09811 14.436C4.22243 16.044 5.374 18 7.19733 18H20.3924C21.0522 18 21.592 17.46 21.592 16.8C21.592 16.14 21.0522 15.6 20.3924 15.6H7.19733L8.51684 13.2H17.4535C18.3532 13.2 19.1449 12.708 19.5527 11.964L23.8471 4.176C24.291 3.384 23.7152 2.4 22.8035 2.4H5.05012L4.24642 0.684C4.05449 0.264 3.62265 0 3.16682 0H1.19955C0.5398 0 0 0.54 0 1.2ZM19.1929 19.2C17.8734 19.2 16.8058 20.28 16.8058 21.6C16.8058 22.92 17.8734 24 19.1929 24C20.5124 24 21.592 22.92 21.592 21.6C21.592 20.28 20.5124 19.2 19.1929 19.2Z",
    fill: "#39363c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.32bba870.svg";
export { ForwardRef as ReactComponent };